import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/product.css";
import ProductCard from "../components/ProductCard";
import Loader from "../components/Loader";
import { Pagination, Stack } from "@mui/material";
import useProductListing from "../hooks/useProductListing";

function Products({ isAuthenticated, onAddToCart }) {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    const [selectedChar, setSelectedChar] = useState("");
    const [sort, setSort] = useState("relevance");

    const navigate = useNavigate();

    // Same two-mode listing as AllProducts: server-paged by default, and the
    // full cached catalogue only when a letter is picked.
    //
    // The random shuffle this page used to apply is gone. It was
    // `[...res].sort(() => Math.random() - 0.5)`, which is both a biased shuffle
    // and incompatible with paging — each page would reorder independently, so a
    // product could appear on two pages or none. "Relevance" now means the
    // catalogue's own order, which is stable across pages.
    const {
        products,
        loading,
        error,
        currentPage,
        totalPages,
        setPage,
    } = useProductListing({ perPage: 30, namePrefix: selectedChar, sort });

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("user_data")) || {};
        if (userData.isSuperAdmin) navigate("/dashboard");
    }, [navigate]);

    if (loading) return <Loader />;

    return (
        <main className="product-section-wrapper">

            {/* PAGE HEADING */}
            <h1 className="all-products-title">
                {selectedChar === "" ? "All Products" : `Products Starting With: ${selectedChar}`}
            </h1>

            {/* ALPHABET FILTER — clicking the active letter clears it. */}
            <div className="alphabet-container">
                {alphabets.map((char) => (
                    <button
                        key={char}
                        className={`alphabet-btn ${selectedChar === char ? "active" : ""}`}
                        onClick={() => setSelectedChar(char === selectedChar ? "" : char)}
                    >
                        {char}
                    </button>
                ))}
            </div>

            {/* SORT DROPDOWN */}
            <div className="section-header">
                <div className="filter-wrapper">
                    <select
                        id="filter"
                        className="filter-select"
                        value={sort}
                        onChange={(e) => setSort(e.target.value)}
                    >
                        <option value="relevance">Relevance</option>
                        <option value="lowToHigh">Price: Low to High</option>
                        <option value="highToLow">Price: High to Low</option>
                    </select>
                </div>
            </div>

            {/* PRODUCT GRID */}
            <section className="product-container">
                <div className="product-grid">
                    {products.length > 0 ? (
                        products.map((product) => (
                            <ProductCard
                                product={product}
                                key={product.id}
                                isAuthenticated={isAuthenticated}
                                onAddToCart={onAddToCart}
                            />
                        ))
                    ) : (
                        <p style={{ textAlign: "center", width: "100%" }}>
                            {error || "No products found"}
                        </p>
                    )}
                </div>
            </section>

            {/* PAGINATION */}
            {totalPages > 1 && (
                <Stack
                    spacing={2}
                    style={{ margin: "40px auto", display: "flex", alignItems: "center" }}
                >
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={(event, value) => setPage(value)}
                        color="primary"
                    />
                </Stack>
            )}
        </main>
    );
}

export default Products;
